import util from '@/utils/util.js'
import { userLogout, userLogin, userLoginToken } from '@/api/system/user'
import router, { resetRouter } from '@/router'
import routes from '@/router/tools'
import CryptoJS from 'crypto-js'

export default {
  namespaced: true,
  actions: {
    /**
     * 用户登录
     */
    async login({ dispatch }, loginInfo) {
      const res = await userLogin(loginInfo)
      res.loginInfo = {
        ...loginInfo,
        pwd: loginInfo.pwd ? CryptoJS.AES.encrypt(loginInfo.pwd, 'peacock').toString() : ''
      }
      await dispatch('saveUserInfo', res)
    },

    /**
     * 用户登录（仅使用token）
     */
    async loginToken({ dispatch }) {
      const res = await userLoginToken({})
      res.loginInfo = {}
      await dispatch('saveUserInfo', res)
    },

    /**
     * 刷新token
     */
    async updateToken({ dispatch }) {
      const loginInfo = await util.db.get('user.login', {}, false)
      if (loginInfo.pwd) {
        loginInfo.pwd = CryptoJS.AES.decrypt(loginInfo.pwd, 'peacock').toString(CryptoJS.enc.Utf8)
        const res = await userLogin(loginInfo)
        util.cookies.set('token', res.returnData.token)
        await dispatch('user/updateToken', res.returnData.token, { root: true })
      } else {
        return Promise.reject(new Error(''))
      }
    },

    /**
     * 退出登录
     */
    async logout({ dispatch }) {
      await userLogout()
      await dispatch('clearUserInfo')
      router.push({ name: 'login' })
    },

    /**
     * 保存用户信息
     */
    async saveUserInfo({ dispatch }, userInfo) {
      util.cookies.set('token', userInfo.returnData.token)
      await dispatch('user/set', userInfo.returnData, { root: true })
      await util.db.set('user.login', userInfo.loginInfo, false)
      await dispatch('load')
    },

    /**
     * 清空用户信息
     */
    async clearUserInfo({ dispatch }) {
      await dispatch('user/set', {}, { root: true })
      await util.db.set('user.login', {}, false)
    },

    /**
     * 用户登录后加载相关用户配置
     */
    async load({ rootState, commit, dispatch }) {
      //加载用户信息
      await dispatch('user/load', null, { root: true })
      //加载页面过渡效果设置
      await dispatch('transition/load', null, { root: true })
      //加载菜单状态
      await dispatch('menu/load', null, { root: true })
      //设置一级菜单
      commit('menu/setMenu', routes.menus(rootState.user.permission), { root: true })
      //设置符合权限的路由
      resetRouter()
      router.addRoutes(routes.routers(rootState.user.permission))
      //加载上次退出时的页面列表
      commit('tab/setAllTabs', routes.tabs(rootState.user.permission), { root: true })
      await dispatch('tab/load', null, { root: true })
      if (rootState.user.info?.accountId) {
        //加载是否提醒
        await dispatch('process/loadRemind', null, { root: true })
        //加载是否完成
        await dispatch('process/loadCompleted', null, { root: true })
      }
    }
  }
}
